import { render, staticRenderFns } from "./CoilsProjectAdvancedDetails.vue?vue&type=template&id=23e818a4&"
import script from "./CoilsProjectAdvancedDetails.vue?vue&type=script&lang=js&"
export * from "./CoilsProjectAdvancedDetails.vue?vue&type=script&lang=js&"
import style0 from "./CoilsProjectAdvancedDetails.vue?vue&type=style&index=0&id=23e818a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports